import React, {useState, useEffect} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import TableSection from 'components/sales/tableSection/tableSection';
import "./refund.css";

const RefundRequest = ({
                           cxOrderRefundList,
                           refundList=[]
                       }) => {
    
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState();

    useEffect(() => {
        (async () => {
            let roleId = localStorage.getItem('fusion-role')
            let category = parseInt(roleId) === 60 ? 23 : parseInt(roleId) === 59 ? 15 : parseInt(roleId) === 63 ? 14 : parseInt(roleId) === 85 ? 80 : 35
            setIsLoading(true);
            await cxOrderRefundList(category, 'REQUESTED', roleId)
            setIsLoading(false);
        })();
    }, []);



    const headers = [
        'Order Id',
        'Ticket Id',
        'Category',
        'Refund Amount',
        'Raised By',
        'Raised On',
        'Action'
    ];

    useEffect(() => {
        const tableData = [
            'id',
            'order_id',
            'ticket_id',
            'category',
            'amount',
            'requester_name',
            'created_at',
            'Action'
        ];

        if (refundList?.data !== undefined && refundList?.data?.length > 0) {
            const data = refundList?.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})
                    ),
                    {
                        Action: [
                            {
                                name: 'View',
                                link: `cx-refund-request-view/${element['order_id']}`,
                            }
                        ]
                    }
                )
            );
            data && setListData(data);
        }
    }, [refundList]);

    const onPageChange = async (val) => {

    };

    return (
        <Layout
            title={localization.refundRequest}
            //isGoback
            isLoading={isLoading}
        >
            <div className="container-fluid">
                <div className={`col-md-12 auto-w-100 auto-design-2 row`}>
                    <div className='col-md-3'>
                        <div className='dash-box dash-pending'>
                            <h5>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" fill="coral"
                                     class="bi bi-clock" viewBox="0 0 16 16">
                                    <path
                                        d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"/>
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"/>
                                </svg>
                                <span className='dash-title'>Pending Requests</span>
                            </h5>
                            <table className='dash-table'>
                                <thead>
                                <tr>
                                    {/*<th>Cashback</th>*/}
                                    <th>Refund</th>
                                </tr>
                                </thead>
                                <tbody className='dash-body'>
                                <tr>
                                    {/*<td>100</td>*/}
                                    <td>{refundList?.summary?.pending_requests?.refund}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='dash-box dash-success'>
                            <h5>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="green"
                                     class="bi bi-check2-circle" viewBox="0 0 16 16">
                                    <path
                                        d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
                                    <path
                                        d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                                </svg>
                                <span className='dash-title'>Approved Requests</span>
                            </h5>
                            <table className='dash-table'>
                                <thead>
                                <tr>
                                    {/*<th>Cashback</th>*/}
                                    <th>Refund</th>
                                </tr>
                                </thead>
                                <tbody className='dash-body'>
                                <tr>
                                    {/*<td>100</td>*/}
                                    <td>{refundList?.summary?.approved_requests?.refund}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='dash-box dash-rejected'>
                            <h5>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" fill="#ee4c4c"
                                     class="bi bi-ban" viewBox="0 0 16 16">
                                    <path
                                        d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>
                                </svg>
                                <span className='dash-title'>Rejected Requests</span>
                            </h5>
                            <table className='dash-table'>
                                <thead>
                                <tr>
                                    {/*<th>Cashback</th>*/}
                                    <th>Refund</th>
                                </tr>
                                </thead>
                                <tbody className='dash-body'>
                                <tr>
                                    {/*<td>100</td>*/}
                                    <td>{refundList?.summary?.rejected_requests?.refund}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='dash-box dash-processed'>
                            <h5>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                                     class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                    <path
                                        d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                                    <path fill-rule="evenodd"
                                          d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                                </svg>
                                <span className='dash-title'>Amount Processed</span>
                            </h5>
                            <table className='dash-table'>
                                <thead>
                                <tr>
                                    {/*<th>Cashback</th>*/}
                                    <th>Refund</th>
                                </tr>
                                </thead>
                                <tbody className='dash-body'>
                                <tr>
                                    {/*<td>100</td>*/}
                                    <td>{refundList?.summary?.amount_processed?.refund}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='col-md-3 dash-top'>
                        <div className='dash-box dash-processed'>
                            <h5>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" fill="currentColor"
                                     class="bi bi-card-list" viewBox="0 0 16 16">
                                    <path
                                        d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"/>
                                    <path
                                        d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8m0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
                                </svg>
                                <span className='dash-title'>Total Requests</span>
                            </h5>
                            <table className='dash-table'>
                                <thead>
                                <tr>
                                    {/*<th>Cashback</th>*/}
                                    <th>Refund</th>
                                </tr>
                                </thead>
                                <tbody className='dash-body'>
                                <tr>
                                    {/*<td>100</td>*/}
                                    <td>{refundList?.summary?.total_requests?.refund}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

            <div className='d-alignment'>
                <div className="card-body">
                    <TableSection
                        data={listData}
                        isId={false}
                        isMngId={false}
                        headers={headers}
                    />
                </div>
            </div>

        </Layout>
    );
};

export default RefundRequest;
